import { useState, useEffect } from 'react';
import ready from 'document-ready';
import translator from '@Components/Utilities/Translator';

const AccessibilitySkipNav = () => {

    const [hasMainContentElement, setHasMainContentElement] = useState(null);
    const [hasFiltersElement, setHasFiltersElement] = useState(null);

    useEffect(() => {
        ready(() => {
            let mainContent = document.querySelector('#main-content');
            let filters = document.querySelector('#filters');

            if (mainContent) {
                setHasMainContentElement(true);
            }

            if (filters) {
                setHasFiltersElement(true);
            }
        });
    }, []);

    return (
        <ul className='a11y-nav'>
            {hasMainContentElement &&
                <li><a rel='nofollow' href='#main-content'><strong>{translator.translate('sandhills.skiptomaincontent')}</strong></a></li>
            }
            {hasFiltersElement &&
                <li><a rel='nofollow' href='#filters'><strong>{translator.translate('sandhills.skiptolistingfilters')}</strong></a></li>
            }
        </ul>
    );
}

export default AccessibilitySkipNav;